import { createAuthClient } from "@cryptolect/auth/client";

const baseURL =
  (import.meta.env.VITE_API_URL as string | undefined) ??
  "https://cryptolect-api-dev.benjamin-t-durham.workers.dev";

export const authClient = createAuthClient({
  baseURL,
  basePath: "/v1/auth",
});

export type AuthClient = typeof authClient;
